var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"footer"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('p',[_vm._v(" © Copyright "+_vm._s(_vm.year)+" - "+_vm._s(_vm.config.appName)+" | "+_vm._s(_vm.config.appDeveloper)+" ")])])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }